<template>
  <div>
    <city-header></city-header>
    <city-search :cities="cities"></city-search>
    <city-list :hotCites="hotCities" :cities="cities" :letter="letter"></city-list>
    <city-alphabet :cities="cities" @change="changeClick"></city-alphabet>
  </div>
</template>


<script>
  import axios from 'axios'
  import CityHeader from './components/Header'
  import CitySearch from './components/Search'
  import CityList from './components/List'
  import CityAlphabet from './components/Alphabet'
  export default{
    name:'City',
    components:{
      CityHeader,
      CitySearch,
      CityList,
      CityAlphabet
    },
    data() {
      return{
         hotCities:[],
         cities:{},
         letter:''
      }
    },
    methods:{
      getCityInfo() {
        axios.get('/travel/static/mock/city.json').then(this.getCityInfoSucc)
      },
      changeClick(letter) {
        this.letter = letter
      },
      getCityInfoSucc(res) {
        res = res.data
        if(res.ret && res.data){
          const data = res.data
          this.cities = data.cities
          this.hotCities = data.hotCities
        }
      }
    },
    mounted() {
    this.getCityInfo()
  }
  }
</script>

<style lang="stylus" scoped>
  
</style>


// WEBPACK FOOTER //
// src/pages/city/City.vue